export const MuiRadio = {
  defaultProps: {
    color: 'secondary'
  }
}
